module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "64.86%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now Charlotte lived on the mountainside,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In a bleak and dreary spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There was no house for miles around,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Except her father’s cot.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "5%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("W")]), _vm._v("hen Jay said he’d downloaded a Ouija-board app on to his phone, I wasn’t surprised. It sounded like the kind of crazy thing he’d do. It was Thursday night and we were sitting in our favorite greasy spoon café, eating baskets of curly fries, like always.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do we have to do this?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Don’t be a spoilsport,” Jay said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put his phone on the table and loaded the app. A Ouija board filled the screen. The words YES and NO were written in flowing script in the top two corners, and beneath them were the letters of the alphabet in that same curling text, in two arches. Beneath that was a straight row of numbers from zero to nine, and underneath was printed GOOD BYE.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Isn’t there some kind of law against Ouija boards or something? I thought they were supposed to be dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dangerous how? It’s only a board with some letters and numbers written on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I heard they were banned in England.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Couldn’t be, or they wouldn’t have made the app. You’re not scared, are you? It’s only a bit of fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am definitely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" scared,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hold your hand over the screen then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So I held out my hand, and Jay did the same, our fingertips just touching.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The planchette thing is supposed to spell out the answers to our questions,” Jay said, indicating the little pointed disc hovering at one corner of the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Without us even touching it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The ghost will move it,” he declared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A ghost that understands cell phones? And doesn’t mind crowds?” I glanced around the packed café. “I thought you were supposed to play with Ouija boards in haunted houses and abandoned train stations.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That would be pretty awesome, Sophie, but since we don’t have any boarded-up lunatic asylums or whatever around here, we’ll just have to make do with what we’ve got. Who shall we try to contact?” Jay asked. “Jack the Ripper? Mad King George? The Birdman of Alcatraz?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rebecca Craig,” I said. The name came out without my really meaning it to.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never heard of her. Who did she kill?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No one. She’s my dead cousin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay raised an eyebrow. “Your what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My uncle who lives in Scotland, he used to have another daughter, but she died when she was seven.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shrugged. “I don’t know. No one really talks about it. It was some kind of accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How well did you know her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not that well. I only met her once. It must have been right before she died. But I always wondered how it happened. And I guess I’ve just been thinking about them again, now that I’m going to stay there over vacation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, let’s ask her how she died. Rebecca Craig,” Jay said. “We invite you to speak with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nothing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rebecca Craig,” Jay said again. “Are you there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not going to work,” I said. “I told you we should have gone to a haunted house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" try calling her?” Jay said. “Perhaps she’ll respond to you better. You’re family, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I looked down at the Ouija board and the motionless planchette. “Rebecca Craig—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t even finish the sentence before the disc started to move. It glided smoothly once around the board before coming back to hover where it had been before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that how spirits say hello, or just the app glitching out?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shh! You’re going to upset the board with your negativity. Rebecca Craig,” Jay said again. “Is that you? Your cousin would like to speak with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re not technically—” I began, but the planchette was already moving. Slowly it slid over to YES, and then quickly returned to the corner of the board.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s obviously got voice-activation software,” I said. With my free hand I reached across the table to steal one of Jay’s fries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tsk-tsked at me, then said, “Spirit, how did you die?” The planchette hovered a little longer this time before sliding over towards the letters and spelling out: B-L-A-C-K")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s that supposed to mean?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not finished,” Jay replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The planchette went on to spell: S-A-N-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Black sand?” I said. “That’s a new one. Maybe she meant to say quicksand? Do they have quicksand in Scotland?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Spirit,” Jay began, but the planchette was already moving again. One by one, it spelled out seven words:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("D-A-D-D-Y")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("S-A-Y-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("N-E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O-P-E-N")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("T-H-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("G-A-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s like a Magic 8 Ball,” I said. “It just comes out with something random each time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shh! It’s not random, we’re speaking with the dead,” Jay said, somehow managing to keep a straight face, even when I stuck my tongue out at him. “Is that why you died, spirit?” he asked. “Because you opened the gate?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The planchette started to move again, gliding smoothly around the lighted screen:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charlotte?” I said. “I thought we were speaking to Rebecca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is your name Charlotte?” Jay asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The planchette moved straight to NO.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you Rebecca Craig?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The planchette did a little jump before whizzing over to YES. And then:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This ghost has a pretty one-track mind,” I said with a yawn. “I hope you didn’t pay a lot of money for this rubbish. Aren’t you supposed to be saving up for a new bike?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, but I hate saving money—it’s so boring. Maybe I’ll get a unicycle instead. Do you think that would make me more popular at school?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I laughed. “Only if you went to clown school. You’d fit right in there. Probably make Head Boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Head Boy, wouldn’t that be something? My mom would die of pride.” Jay looked down at the board and said, “You know, some people think that spirits can see into the future. Let’s give it a little test. Rebecca, am I ever going to grow another couple of inches taller?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I giggled as the planchette whizzed around, apparently at random.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("N-E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O-P-E-N")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("T-H-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("G-A-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("D-A-D-D-Y")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("S-A-Y-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("D-A-D-D-Y")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("S-A-Y-S")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("T-H-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("G-A-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("N-E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("E-V-E-R")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think I should take that as a no?” Jay asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Absolutely. Short for life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay pretended to recoil. “Geez, you don’t have to be vicious about it.” He looked back down at the board. “Spirit, am I going to pass that math quiz tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("B-L-A-C-K")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("S-A-N-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("F-R-O-Z-E-N")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("F-R-O-Z-E-N")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("S-A-N-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("B-L-A-C-K")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-H-A-R-L-O-T-T-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("C-O-L-D")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("H-E-R-E")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("D-A-D-D-Y")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay and I were both giggling now, like little kids, but his next, and final, question made the laugh stick in my throat. “When will I die?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This time the planchette gave a different answer. It whizzed around the board aimlessly once again before clearly spelling out seven letters:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("T-O-N-I-G-H-T")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think this ghost likes me very much,” Jay said, lifting his eyes to mine. “What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But before I could respond, we both jumped as a tinkly, music-box style tune started to play from Jay’s phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that your new ringtone?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve never heard it before,” Jay replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now you’re just messing with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head and gave me his best innocent look. “It must be part of the app. To make it more spooky.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A girl’s voice started to sing—plaintive and childish, high-pitched and wobbly. It was a simple, lilting melody full of melancholy, a song made for quiet campfires, lonely hills, and cold nights:")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "3%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now Charlotte lived on the mountainside,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In a bleak and dreary spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There was no house for miles around,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-bottom": "3%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Except her father’s cot.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are such a wind-up,” I said, smiling and giving Jay’s arm a shove. The singsong voice was starting to get us dirty looks from the other customers in the café. “You put that on there yourself!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I swear I didn’t,” Jay replied. “It’s just a really cool app.”")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "3%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Such a dreadful night I never saw,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The reins I scarce can hold.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fair Charlotte shivering faintly said,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-bottom": "3%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I am exceedingly cold.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay tapped the screen to turn it off but, though the voice stopped singing, the Ouija board screen wouldn’t close. The planchette started spinning around the board manically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dude, I think that app has broken your phone,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was only a joke. I didn’t really think there was anything wrong with the phone that turning it off and on again wouldn’t fix, but then the screen light started to flicker, and all the lights in the café flickered with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay and I looked at each other and I saw the first glimmer of uncertainty pass over his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then every light in the café went out, leaving us in total darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were grumblings and mutterings from the other customers around us and, somewhere in the room, a small child started to cry. We heard the loud crash of something being dropped in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only light in the room came from the glow of Jay’s phone, still on the table between us. I looked at it and saw the planchette fly over to number nine and then start counting down through the numbers. When it got to zero, someone in the café screamed, a high, piercing screech that went on and on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cold, clammy fingers curled around mine as Jay took my hand in the darkness and squeezed it tight. I could hear chairs scraping on the floor as people stood up, demanding to know what was happening. More children started to cry, and I could hear glasses and things breaking as people tried to move around in the dark and ended up bumping into tables. And above it all was the piercing sound of a woman crying hysterically, as if something really awful was happening to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I let go of Jay’s hand and twisted around in my seat, straining my eyes, peering into the darkness, desperately trying to make sense of what was happening. Now that my eyes had adjusted, I could just make out the silhouettes of some of the other people in the café with us—plain black shapes, like shadow puppets dancing on a wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But one of them was taller than all the others, impossibly tall, and I realized that whoever it was must be standing on one of the tables. They weren’t moving, not at all. Everyone else in the café was moving, even if only turning their heads this way and that, but this person stood stock-still. I couldn’t even tell if I was looking at their back or their front—they were just staring straight ahead, arms by their sides.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you see that?” I said, but my voice got lost amongst all the others. I stood up and took half a step forward, staring through the shadows. I could just make out the outline of long hair and a skirt. It was a girl standing on the table in the middle of all this chaos. No one else seemed to have noticed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jay—” I began, turning back towards him at the exact moment his phone died. The screen light flickered and then went off. At the same time, the café lights came back on. I spun back around to look at the table where the girl had been standing, but there was no one there. The table was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you see her?” I asked Jay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“See who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stared around for the girl in a skirt, but there was no sign of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anyone would think there’d been an earthquake or something. There was broken china and glass all over the floor of the café, many of the chairs had fallen over, and a couple of tables had overturned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who was that screaming?” people were saying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is someone hurt?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the hell is going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh my God, someone’s been burnt!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bill, the owner, had led one of the waitresses out from the kitchen. She must have been the one who’d screamed in the dark. She was still sobbing and it was obvious why—all the way up her right side she was covered in burns. Her hand, arm, shoulder, and the right side of her face were completely covered in a mess of red and black bleeding flesh, so charred that it was hard to believe it had once been normal skin. Her hair was still smoking and the smell made me want to gag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I heard someone on their phone calling an ambulance as other people moved forward, asking what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know,” Bill said. He’d gone completely white. “I don’t know how it happened. When the lights went out, she must have tripped or something. I think … I think she must have fallen against the deep-fat fryer …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I could feel the blood pounding in my ears and turned back around to Jay. Wordlessly, he held up his phone for me to see. From the top of the screen to the bottom there was a huge crack running all the way down the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you … Did you drop it?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Jay just shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ambulance arrived soon after that and took the weeping girl away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In all the years this place has been open we’ve never had an accident like this,” I heard Bill say. “Never.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bill went to the hospital with the girl, and the café closed early. Everyone filed away, going out to their cars and driving off. Soon Jay and I were the only ones left. Normally, he would have biked home and I would have waited by myself for my mom to pick me up, but today Jay said he would wait with me, and I was grateful to him for that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks,” I said. “And thanks for holding my hand when the lights went out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave me a sharp look. “I didn’t hold your hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A prickly feeling started to creep over my skin. “Yes, you did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sophie, I didn’t. You must have … You must have imagined it. It was pretty crazy in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thought of those cold fingers curling around mine and shook my head. “Someone was definitely holding my hand when it went dark,” I said. “And if it wasn’t you, then who was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, it wasn’t me. Maybe you’ve got a secret admirer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you see that girl standing on the table? I thought I saw her outline there in the dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay stared at me. “Are you actually trying to scare me right now? Because it’s not going to work, you know. I’m not that gullible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I glanced back through the windows of the café. There’d been no time to tidy up before the ambulance arrived and the place had been shut up as it was, with tables and chairs and broken china everywhere. A couple of the tables looked fairly normal, with plates of untouched food still on them, which was almost weirder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shivered and turned away, not wanting to look too closely in case I saw the girl among the empty tables.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look,” Jay said. “It all got a bit crazy when the lights went out because of the waitress who hurt herself and started screaming. If it hadn’t been for that, none of this would be any big deal. It was just a freak accident, that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My mom pulled into the parking lot then, waving at me through the window.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We could give you a lift,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay’s house wasn’t very far away and he always biked home, but I couldn’t stop thinking of that final question he had asked the Ouija board: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When will I die?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No thanks,” Jay said. “I’ll bike back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I hesitated. “Jay …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not still worrying about that app, are you? Nothing’s going to happen to me,” he said. Then he grinned. “But just promise me one thing. If I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" come to some appalling, grisly end tonight, I hope I can rely on you to tell the world it was a ghost that did me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For once I didn’t smile. “Don’t,” I said. “Don’t joke about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay laughed and put his arm around my shoulders in a friendly squeeze. “I think you really would miss me,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Behind us, Mom honked her car horn to tell me to hurry up. Jay gave her a wave and said, “I’ll see you tomorrow at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. See you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I turned and started to walk across the parking lot but had only gone a few steps when I stopped and turned back. “Hey, Jay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will you do me a favor?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you take the towpath tonight? Please?” Jay usually biked back home using the shortest route, which meant several busy roads. He did it all the time and nothing had ever happened to him. I knew I was being silly. But if he went the other way, he’d miss all the major traffic and only add five minutes to his journey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was afraid that he’d refuse, or make a joke of it, or tease me again. But instead he just nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right, Sophie. I’ll take the towpath.” Then he grinned, blew me a mock kiss, and said, “Anything for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I got into the front seat of Mom’s car and waved at Jay as we drove past, keeping my eyes on him until the car turned the corner and I lost him from sight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t really want to talk to Mom about what had happened at the café, so when we got home I went straight upstairs and had a bath. Before going to bed I sent Jay a text to say good-night. It wasn’t something I’d normally do, but I just wanted to reassure myself that he’d gotten home okay. He sent me a one-word answer: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Good-bye.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I guessed he’d meant to say good-night but his autocorrect had changed it and he hadn’t noticed. He’d replied, though, so at least I knew he was home. I got into bed and went to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t remember until the next day that when Jay had shown me his phone at the café, it had been broken.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceOrnament",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/sborn.jpg",
      "width": "40%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("My dreams were filled with Ouija boards and burning hair and little girls holding my hand in the dark. And Jay inside a coffin. I tossed and turned all night. It was so bad that it was a relief to wake up, and I got out of bed in the morning without Mom having to drag me for a change.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the sun shining in through the windows, the events of the night before started to seem less terrible. So the lights had gone out and someone had hurt themselves. It was horrible for that poor waitress but it had just been an accident, plain and simple. In the light of day, there didn’t seem to be anything that strange about it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I dressed quickly, for once actually looking forward to school. Jay would be outside soon and we’d walk there together, like we always did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I got ready I was vaguely aware of the phone ringing downstairs and the sound of Mom’s voice as she answered it, but I didn’t really pay it too much attention. By the time I went downstairs for breakfast, Mom was just hanging up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who was that?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t answer straight away, and when I looked at her and saw her face I knew instantly that something was very wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What is it?” I said. “Who was that on the phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sophie,” Mom said, her voice all strained and weird-sounding. “I don’t … I don’t know how to tell you this … Sweetheart, you need to brace yourself—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _vm._v("? What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Jay. That was his dad on the phone. Something’s happened. He … He never made it home last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, he did,” I said at once. “He texted me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But at that very second I remembered that Jay’s phone was broken. I pulled my cell phone out of my pocket and started scrolling through, looking for his text, but it wasn’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t understand. He sent me a text last night. I saw it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sophie, he didn’t send you a text. Oh, sweetheart, I’m so, so sorry, but … On the way home he had an accident. They think … They think that perhaps the brakes on his bike failed. He went into the canal. By the time they pulled him out, it was too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("too late")]), _vm._v("?” I said, clenching my hands so tight that I felt my nails tear the skin of my palms. “Jay’s a strong swimmer. He won almost all the swim meets at school last year. If he’d fallen into the canal, he would have just swum to the side and climbed out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Mom was shaking her head. “They think he must have hit his head when he fell in. Sophie, he drowned.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It could not possibly be true. And yet, it was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jay was gone.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0e41d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545941099_ch001.vue
// module id = 69
// module chunks = 0